import React from 'react';

const SvgMarkerTripStart = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 30 44" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="MarkerTripStart_svg__a" d="M730 471c-8.293 0-15 6.886-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.514-6.707-15.4-15-15.4" />
    </defs>
    <use width="100%" height="100%" xlinkHref="#MarkerTripStart_svg__a" transform="translate(-715 -471)" fill="#2fa0a0" />
    <path d="M22 15l-11.471 6.623V8.377z" fill="#fff" stroke="#fff" strokeLinejoin="round" strokeWidth={1.47} />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgMarkerTripStart svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/MarkerTripStart.js